import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";

const ProgressBar = ({ instance }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress
          variant="determinate"
          value={
            instance.isActive()
              ? Number(instance.getPercentageTowardsLevel())
              : 0
          }
        />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${
          instance.isActive() ? instance.getPercentageTowardsLevel() : 0
        }%`}</Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;
